import { GET_EXTRAS, SET_EXTRAS } from './action-types';
import { getRequestStatus } from '../../requests/selectors';

export const [isFetching, hasErrorFetching, errorDataFetching] = getRequestStatus(GET_EXTRAS);
export const [isSaving, hasErrorSaving, errorDataSaving] = getRequestStatus(SET_EXTRAS);

export const extras = (state) => state.booking.extras.extras;
export const showDiscountBox = (state) => state.booking.extras.showDiscountBox === "true";
